import type { Context, Next } from "hono";

/**
 * 🔍 A LENTE "VER COMO" É SÓ LEITURA — NO SERVIDOR (decisão de 09/10, S1/A7; auditoria 3 rodada 2, N4, 14/10).
 *
 * O A7 valia na tela (`usePapelEfetivo`) e na Duda (`routes/duda.ts`), não no servidor: sob `X-Ver-Como` do cliente o
 * operador criou um achado (POST /achados → 201). Um botão que escape da tela gravava "como se fosse prévia". Agora
 * TODO pedido de escrita (≠ GET/HEAD/OPTIONS) que chega sob a lente — header `X-Ver-Como` ou `?como=` — é recusado com
 * 403 e a frase, ANTES de qualquer handler. Sem lente, nada muda.
 *
 * Exceções (POST que não grava dado de negócio): a conversa da Duda (ela mesma recusa o resto de /duda/*), a telemetria
 * da tela, e duas contas puras (calcular vencimento, diagnóstico da planilha "traga a sua", que não gravam nada).
 */
export const METODOS_DE_LEITURA = new Set(["GET", "HEAD", "OPTIONS"]);
export const ESCRITAS_LIBERADAS_NA_LENTE: readonly RegExp[] = [
  /^\/api\/duda\/chat\/?$/,
  /^\/api\/telemetria\//,
  /^\/api\/regula\/calcular-vencimento\/?$/,
  /^\/api\/regula\/planilha\/diagnostico\/?$/,
];
export const RECUSA_DA_LENTE = {
  error: "lente_so_leitura",
  message: "Você está na prévia \"ver como\": ela é só leitura. Nada foi gravado. Saia da prévia para agir com a sua conta.",
} as const;

/** PURA. `true` = o pedido é escrita sob a lente e deve ser recusado. */
export function lenteBarraEscrita(metodo: string, caminho: string, temLente: boolean): boolean {
  if (!temLente || METODOS_DE_LEITURA.has(metodo.toUpperCase())) return false;
  return !ESCRITAS_LIBERADAS_NA_LENTE.some((re) => re.test(caminho));
}

/** O middleware (montado em `/api/*` depois do auth). */
export async function lenteSoLeitura(c: Context<any>, next: Next) {
  const temLente = !!(c.req.header("X-Ver-Como") || c.req.query("como"));
  if (lenteBarraEscrita(c.req.method, c.req.path, temLente)) return c.json(RECUSA_DA_LENTE, 403);
  await next();
}
